import { v4 as uuid } from 'uuid'
import { IPriceListEntry, PriceListEntry } from '../PriceList/PriceListEntry/PriceListEntry'

export interface IMasterCatalog {
	id: string
	companyId: string
	entries: IPriceListEntry[]
}

export class MasterCatalog implements IMasterCatalog {
  public id: string = uuid()
  public entries: PriceListEntry[] = []

  constructor(public companyId: string) {}
}